import React, { Fragment } from 'react';
import { TableRow, TableCell } from "@mui/material";

const ProfitTableRow = (props) => {
    const { alignment, checked, fontsize, row, idx, onUserIdClick } = props;

    const cellBorderSx = {
        border: '1px solid #aaa',
        '.dark &': {
            borderColor: '#E0F2FF85',
        },
    };

    const rolePrefix = row.subRoleId === 2 ? "Sm" : row.subRoleId === 3 ? "M" : row.subRoleId === 4 ? "Ag" : "U";
    const singleMember = row.member.find(item => item.single)?.single || {};
    const mixMember = row.member.find(item => item.mix)?.mix || {};

    const singleAdmin = row.admin.find(item => item.single)?.single || {};
    const mixAdmin = row.admin.find(item => item.mix)?.mix || {};

    const singleCompany = row.company.find(item => item.single)?.single || {};
    const mixCompany = row.company.find(item => item.mix)?.mix || {};

    const memberTotalWL = (checked.mix || (!checked.mix && !checked.single) ? mixMember.wl : 0) + (checked.single || (!checked.mix && !checked.single) ? singleMember.wl : 0);
    const memberTotalCom = (checked.mix || (!checked.mix && !checked.single) ? mixMember.com : 0) + (checked.single || (!checked.mix && !checked.single) ? singleMember.com : 0);
    const memberTotal = (checked.mix || (!checked.mix && !checked.single) ? mixMember.total : 0) + (checked.single || (!checked.mix && !checked.single) ? singleMember.total : 0);

    const adminTotalWL = (checked.mix || (!checked.mix && !checked.single) ? mixAdmin.wl : 0) + (checked.single || (!checked.mix && !checked.single) ? singleAdmin.wl : 0);
    const adminTotalCom = (checked.mix || (!checked.mix && !checked.single) ? mixAdmin.com : 0) + (checked.single || (!checked.mix && !checked.single) ? singleAdmin.com : 0);
    const adminTotal = (checked.mix || (!checked.mix && !checked.single) ? mixAdmin.total : 0) + (checked.single || (!checked.mix && !checked.single) ? singleAdmin.total : 0);

    const companyTotalWL = (checked.mix || (!checked.mix && !checked.single) ? mixCompany.wl : 0) + (checked.single || (!checked.mix && !checked.single) ? singleCompany.wl : 0);
    const companyTotalCom = (checked.mix || (!checked.mix && !checked.single) ? mixCompany.com : 0) + (checked.single || (!checked.mix && !checked.single) ? singleCompany.com : 0);
    const companyTotal = (checked.mix || (!checked.mix && !checked.single) ? mixCompany.total : 0) + (checked.single || (!checked.mix && !checked.single) ? singleCompany.total : 0);

    return (
        <Fragment>

            {/* Row 1 - Single */}
            <TableRow key={`${idx}-single`} className={`bg-customFontMilkWhite ${fontsize} dark:bg-custom_dark_background`}>
                <TableCell rowSpan={3} align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} dark:text-customWhite`}>{idx + 1}</span>
                </TableCell>
                <TableCell rowSpan={3} align={alignment} sx={cellBorderSx}>
                    <button
                        type="button"
                        className={`${fontsize} text-custom_dark_background underline underline-offset-2 hover:text-red-800 dark:text-customLightYellow dark:hover:text-customFontYellow`}
                        onClick={() => onUserIdClick?.(row)}
                    >
                        {row.userId}
                    </button>
                    <span className='text-customFontVoilet text-[10px] font-semibold'> ({rolePrefix})</span>
                </TableCell>
                <TableCell rowSpan={3} align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} dark:text-customWhite`}>{row.name}</span>
                </TableCell>
                <TableCell rowSpan={3} align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} dark:text-customWhite`}>{row.amount}</span>
                </TableCell>
                {
                    checked.single ?
                        <Fragment>
                            <TableCell className='bg-gray-100 dark:bg-custom_dark_background' sx={cellBorderSx}>
                                <span className='bg-gray-100 dark:bg-custom_dark_background text-customFontVoilet font-medium'>Single</span>
                            </TableCell>
                            {/* Member */}
                            <TableCell align={alignment} className='bg-gray-100 dark:bg-custom_dark_background' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleMember.wl < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleMember.wl || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-gray-100 dark:bg-custom_dark_background' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleMember.com < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleMember.com || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-gray-100 dark:bg-custom_dark_background' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleMember.total < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleMember.total || 0}</span>
                            </TableCell>

                            {/* Admin */}
                            <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleAdmin.wl < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleAdmin.wl || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleAdmin.com < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleAdmin.com || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleAdmin.total < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleAdmin.total || 0}</span>
                            </TableCell>

                            {/* Company */}
                            <TableCell align={alignment} className='bg-gray-100 dark:bg-custom_dark_background' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleCompany.wl < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleCompany.wl || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-gray-100 dark:bg-custom_dark_background' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleCompany.com < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleCompany.com || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-gray-100 dark:bg-custom_dark_background' sx={cellBorderSx}>
                                <span className={`${fontsize} ${singleCompany.total < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{singleCompany.total || 0}</span>
                            </TableCell>
                        </Fragment> : null
                }
            </TableRow>

            {/* Row 2 - Mix */}
            <TableRow key={`${idx}-mix`} className="border-b-1 border-b-black border-t-1 border-t-black dark:bg-custom_dark_background">
                {
                    checked.mix ?
                        <Fragment>
                            <TableCell align={alignment} sx={cellBorderSx}>
                                <span className='text-customFontGreen font-medium'>Mix</span>
                            </TableCell>
                            {/* Member */}
                            <TableCell align={alignment} sx={cellBorderSx}>
                                <span className={`${fontsize} ${mixMember.wl < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixMember.wl || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} sx={cellBorderSx}>
                                <span className={`${fontsize} ${mixMember.com < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixMember.com || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} sx={cellBorderSx}>
                                <span className={`${fontsize} ${mixMember.total < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixMember.total || 0}</span>
                            </TableCell>

                            {/* Admin */}
                            <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                                <span className={`${fontsize} ${mixAdmin.wl < 0 ? 'text-red-500' : 'text-black dark:text-customWhite '}`}>{mixAdmin.wl || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                                <span className={`${fontsize} ${mixAdmin.com < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixAdmin.com || 0}</span>
                            </TableCell>
                            <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                                <span className={`${fontsize} ${mixAdmin.total < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixAdmin.total || 0}</span>
                            </TableCell>

                            {/* Company */}
                            <TableCell align={alignment} sx={cellBorderSx}><span className={`${fontsize} ${mixCompany.wl < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixCompany.wl || 0}</span></TableCell>
                            <TableCell align={alignment} sx={cellBorderSx}><span className={`${fontsize} ${mixCompany.com < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixCompany.com || 0}</span></TableCell>
                            <TableCell align={alignment} sx={cellBorderSx}><span className={`${fontsize} ${mixCompany.total < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'}`}>{mixCompany.total || 0}</span></TableCell>
                        </Fragment> : null
                }
            </TableRow>

            {/* Row 3 - Total */}
            <TableRow key={`${idx}-total`} className="bg-gray-300 dark:bg-custom_dark_primary2">
                <TableCell align={alignment} sx={cellBorderSx}><span className='font-medium dark:text-customWhite'>Total</span></TableCell>

                {/* Member */}
                <TableCell align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} ${memberTotalWL < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{memberTotalWL.toFixed(2)}</span>
                </TableCell>
                <TableCell align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} ${memberTotalCom < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{memberTotalCom.toFixed(2)}</span>
                </TableCell>
                <TableCell align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} ${memberTotal < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{memberTotal.toFixed(2)}</span>
                </TableCell>

                {/* Admin */}
                <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                    <span className={`${fontsize} ${adminTotalWL < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{adminTotalWL.toFixed(2)}</span>
                </TableCell>
                <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                    <span className={`${fontsize} ${adminTotalCom < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{adminTotalCom.toFixed(2)}</span>
                </TableCell>
                <TableCell align={alignment} className='bg-yellow-200 dark:bg-customAltas/80' sx={cellBorderSx}>
                    <span className={`${fontsize} ${adminTotal < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{adminTotal.toFixed(2)}</span>
                </TableCell>

                {/* Company */}
                <TableCell align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} ${companyTotalWL < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{companyTotalWL.toFixed(2)}</span>
                </TableCell>
                <TableCell align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} ${companyTotalCom < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{companyTotalCom.toFixed(2)}</span>
                </TableCell>
                <TableCell align={alignment} sx={cellBorderSx}>
                    <span className={`${fontsize} ${companyTotal < 0 ? 'text-red-500' : 'text-black dark:text-customWhite'} font-bold`}>{companyTotal.toFixed(2)}</span>
                </TableCell>
            </TableRow>

        </Fragment>
    )
}

export default ProfitTableRow;



